var map = {
	"./1.gif": 16,
	"./10.gif": 17,
	"./11.gif": 18,
	"./12.gif": 19,
	"./13.gif": 20,
	"./14.gif": 21,
	"./15.gif": 22,
	"./16.gif": 23,
	"./17.gif": 24,
	"./18.gif": 25,
	"./19.gif": 26,
	"./2.gif": 27,
	"./20.gif": 28,
	"./21.gif": 29,
	"./22.gif": 30,
	"./3.gif": 31,
	"./4.gif": 32,
	"./5.gif": 33,
	"./6.gif": 34,
	"./7.gif": 35,
	"./8.gif": 36,
	"./9.gif": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;